import { uploadFilesType } from "../constants/uploadFilesType";
import { API_STATUS } from "../../constant/constant";

const initialState = {
  flow: "upload file",
  isError: false,
  isLoading: false,
};

export const createUploadFilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case uploadFilesType.POST_UPLOAD_FILE_PENDING:
      return {
        ...state,
        status: API_STATUS.PENDING,
        isError: false,
        isLoading: true,
      };
    case uploadFilesType.POST_UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        status: API_STATUS.SUCCESS,
        ...action.data,
        isError: false,
        isLoading: false,
      };
    case uploadFilesType.POST_UPLOAD_FILE_FAILURE:
      return {
        ...state,
        status: API_STATUS.FAILURE,
        isError: true,
        isLoading: false,
        error: { ...action.error },
      };
    default:
      return state;
  }
};
